"use strict";

import debounce from "lodash/debounce";

var MIN_CHARS                 = 1;
var UP_KEY                    = 38;
var DOWN_KEY                  = 40;
var SUGGESTIONS_CACHE_VERSION = 2;

function buildSearchAjaxUrl(query) {
    var $input  = $(".js-plp-search-input");
    var ajaxUrl = $input.data("ajax-url");

    if (!ajaxUrl) {
        return "";
    }

    var url           = new URL(ajaxUrl, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach(function (value, key) {
        if (key !== "q" && key !== "start") {
            url.searchParams.set(key, value);
        }
    });

    if (query && query.trim()) {
        url.searchParams.set("q", query.trim());
    } else {
        url.searchParams.delete("q");
    }

    url.searchParams.delete("start");

    return url.toString();
}

function updateBrowserUrl(query) {
    var url        = new URL(window.location.href);
    var categoryId = $(".js-plp-search input[name=\"cgid\"]").val();

    if (categoryId) {
        url.searchParams.set("cgid", categoryId);
    }

    if (query && query.trim()) {
        url.searchParams.set("q", query.trim());
    } else {
        url.searchParams.delete("q");
    }

    url.searchParams.delete("start");
    window.history.pushState(null, "", url.toString());
}

function togglePlpEmptyState(isEmpty) {
    $(".plp-content-column").toggleClass("is-empty-results", isEmpty);
    $("#product-grid").toggleClass("product-grid--empty", isEmpty);
}

function clearPlpSearch() {
    var $searchBar = $(".js-plp-search");
    var $input     = $searchBar.find(".js-plp-search-input");
    var $field     = $input.closest(".js-plp-search-field");

    $input.val("");
    $field.removeClass("is-submitted is-typing is-focused");
    $field.find(".js-plp-search-clear").removeClass("is-visible");
    hideSuggestions($field.find(".js-plp-search-suggestions"), $input);
    executeSearch("");
}

function updateFieldState($field, query) {
    var hasValue = !!(query && query.trim());

    $field.toggleClass("is-submitted", hasValue);
    $field.find(".js-plp-search-clear").toggleClass("is-visible", hasValue);
}

function hideSuggestions($suggestions, $input) {
    $suggestions.empty().removeClass("is-open");
    $input.attr("aria-expanded", "false");
}

function showSuggestions($suggestions, $input) {
    $suggestions.addClass("is-open");
    $input.attr("aria-expanded", "true");
}

function fetchSuggestions($input) {
    var query          = $input.val();
    var $field         = $input.closest(".js-plp-search-field");
    var $suggestions   = $field.find(".js-plp-search-suggestions");
    var suggestionsUrl = $input.data("suggestions-url");
    var categoryId     = $input.closest(".js-plp-search").find("input[name=\"cgid\"]").val();

    updateFieldState($field, query);

    if (!query || query.trim().length < MIN_CHARS) {
        hideSuggestions($suggestions, $input);
        return;
    }

    $.ajax({
        url: suggestionsUrl,
        method: "GET",
        data: {
            q: query.trim(),
            cgid: categoryId,
            suggestionFilterVersion: SUGGESTIONS_CACHE_VERSION
        },
        success: function (response) {
            $suggestions.empty();

            if (typeof response === "string" && response.trim()) {
                $suggestions.html(response);
                showSuggestions($suggestions, $input);
            } else {
                hideSuggestions($suggestions, $input);
            }
        }
    });
}

function updatePlpSearchResults(response) {
    var $results   = $(response);
    var $noResults = $results.filter(".search-no-results").add($results.find(".search-no-results")).first();

    if ($noResults.length) {
        togglePlpEmptyState(true);
        $("#product-grid").empty().append($noResults.first().clone());
        return;
    }

    togglePlpEmptyState(false);

    var $productGrid = $results.find("#product-grid").first();

    if ($productGrid.length) {
        $("#product-grid").html($productGrid.html());
    }

    var $refinements = $results.find(".refinements").first();

    if ($refinements.length) {
        $(".refinement-bar .refinements").first().html($refinements.html());
    }
}

function executeSearch(query, updateUrl) {
    var searchUrl    = buildSearchAjaxUrl(query);
    var $input       = $(".js-plp-search-input");
    var $field       = $input.closest(".js-plp-search-field");
    var $suggestions = $field.find(".js-plp-search-suggestions");

    if (!searchUrl) {
        return;
    }

    hideSuggestions($suggestions, $input);
    updateFieldState($field, query);
    $field.addClass("is-submitted");

    $.spinner().start();

    $.ajax({
        url: searchUrl,
        method: "GET",
        success: function (response) {
            try {
                updatePlpSearchResults(response);

                if (updateUrl !== false) {
                    updateBrowserUrl(query);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("PLP search update failed", error);
            }
        },
        error: function () {
            // eslint-disable-next-line no-console
            console.error("PLP search request failed");
        },
        complete: function () {
            $.spinner().stop();
        }
    });
}

function handleSuggestionKeyboard(event, $suggestions, $input) {
    var $items = $suggestions.find(".js-plp-search-suggestion");

    if (!$items.length) {
        return;
    }

    var $selected     = $items.filter(".is-active");
    var selectedIndex = $selected.length ? $items.index($selected) : -1;

    if (event.which === DOWN_KEY) {
        event.preventDefault();
        var nextIndex = selectedIndex < $items.length - 1 ? selectedIndex + 1 : 0;

        $items.removeClass("is-active").eq(nextIndex).addClass("is-active");
        $input.attr("aria-activedescendant", $items.eq(nextIndex).attr("id") || "");
    } else if (event.which === UP_KEY) {
        event.preventDefault();
        var prevIndex = selectedIndex > 0 ? selectedIndex - 1 : $items.length - 1;

        $items.removeClass("is-active").eq(prevIndex).addClass("is-active");
        $input.attr("aria-activedescendant", $items.eq(prevIndex).attr("id") || "");
    } else if (event.which === 13) {
        if ($selected.length) {
            event.preventDefault();
            var value = $selected.data("value");

            $input.val(value);
            executeSearch(value);
        } else {
            event.preventDefault();
            executeSearch($input.val());
        }
    } else if (event.which === 27) {
        hideSuggestions($suggestions, $input);
    }
}

function initPlpSearchBar() {
    var $searchBar = $(".js-plp-search");

    if (!$searchBar.length) {
        return;
    }

    var debouncedFetch = debounce(function ($input) {
        fetchSuggestions($input);
    }, 250);

    $searchBar.on("submit", function (event) {
        event.preventDefault();
        var $input = $searchBar.find(".js-plp-search-input");

        executeSearch($input.val());
    });

    $searchBar.on("input", ".js-plp-search-input", function () {
        var $input = $(this);

        $input.closest(".js-plp-search-field").addClass("is-typing");

        debouncedFetch($input);
    });

    $searchBar.on("focus", ".js-plp-search-input", function () {
        var $input = $(this);
        var $field = $input.closest(".js-plp-search-field");

        $field.addClass("is-focused");

        if ($input.val().trim().length >= MIN_CHARS) {
            fetchSuggestions($input);
        }
    });

    $searchBar.on("blur", ".js-plp-search-input", function () {
        var $input = $(this);
        var $field = $input.closest(".js-plp-search-field");

        window.setTimeout(function () {
            $field.removeClass("is-focused is-typing");
        }, 150);
    });

    $searchBar.on("keydown", ".js-plp-search-input", function (event) {
        var $input       = $(this);
        var $suggestions = $input.closest(".js-plp-search-field").find(".js-plp-search-suggestions");

        if ($suggestions.hasClass("is-open")) {
            handleSuggestionKeyboard(event, $suggestions, $input);
        } else if (event.which === 13) {
            event.preventDefault();
            executeSearch($input.val());
        }
    });

    $searchBar.on("mousedown", ".js-plp-search-suggestion", function (event) {
        event.preventDefault();
    });

    $searchBar.on("click", ".js-plp-search-suggestion", function () {
        var value  = $(this).data("value");
        var $input = $searchBar.find(".js-plp-search-input");

        $input.val(value);
        executeSearch(value);
    });

    $searchBar.on("click", ".js-plp-search-clear", function () {
        clearPlpSearch();
    });

    $(document).on("click", function (event) {
        if (!$(event.target).closest(".js-plp-search").length) {
            var $input = $searchBar.find(".js-plp-search-input");

            hideSuggestions($input.closest(".js-plp-search-field").find(".js-plp-search-suggestions"), $input);
        }
    });

    $searchBar.find(".js-plp-search-input").each(function () {
        updateFieldState($(this).closest(".js-plp-search-field"), $(this).val());
    });

    togglePlpEmptyState($("#product-grid .search-no-results").length > 0);
}

export default {
    init: initPlpSearchBar
};
